
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Breadcrumbs, Chip, Menu,
    Stack
} from '@mui/material';
import Link from '@mui/material/Link';

import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { set } from 'lodash';
import { FieldA } from './form';
import { useHistory, useLocation, useParams } from "react-router-dom";
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';


export const ToolBar = ({ name, buttons, filters, breadCrumbs, onClearFilter, height, open, handleClose, anchorEl, handleClick, flex }) => {
    const { list, active } = (breadCrumbs || {})
    const history = useHistory()

    // console.log(buttons, 'buttons');

    return (
        <>
            <Box sx={{
                display: 'flex',
                width: '100%',
                // mt: 2
            }}>
                <Box sx={{
                    display: 'flex', background: 'white', width: '100%',
                    // height: height || '2.5em',
                    borderRadius: '.2em',
                    boxShadow: 0,
                    alignItems: flex ? 'start' : 'center',
                    justifyContent: 'space-between', flexDirection: flex || 'row'
                }}>
                    <Box sx={{ display: 'flex' }}>
                        <Typography variant='h5'>{name}&nbsp;</Typography>
                        {
                            Array.isArray(list) && list.length > 0 &&
                            <Box>
                                <Breadcrumbs aria-label="breadcrumb">
                                    {
                                        list.map((l, i) => {
                                            return (<Typography key={i} sx={{ fontSize: '.9em', cursor: 'pointer' }} underline="hover" color="inherit" onClick={() => {
                                                if (l.onClick) {
                                                    l.onClick()
                                                    return;
                                                }
                                                history.push(l.link)
                                            }}>
                                                {l.name}
                                            </Typography>)
                                        })
                                    }


                                    <Typography color="text.primary">{active.name}</Typography>
                                </Breadcrumbs>
                            </Box>
                        }

                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        rowGap: 3
                        //  alignItems: 'center',
                        // flexWrap: 'wrap'
                    }}>
                        {
                            Array.isArray(buttons) &&
                            <Stack direction={{
                                xs: "row",
                                md: "row"
                            }}
                                flexWrap="wrap"
                                rowGap={1}
                            >
                                {
                                    buttons.map((button, i) => {
                                        const { name, onClick, type, icon, disable, sxx } = button

                                        return (
                                            <Box key={i} sx={{ ml: 1 }}>
                                                {
                                                    type == 'chip' &&
                                                    <Chip label={name} icon={icon()} variant="outlined" onClick={onClick} />
                                                }
                                                {
                                                    type != 'chip' &&
                                                    <Button variant="outlined" onClick={onClick} size='small' disabled={disable} sx={{ width: 'max-content', ...(sxx || {}) }}>
                                                        {icon ? icon() : ''} &nbsp;{name}
                                                    </Button>
                                                }
                                                {
                                                    button.dropDown &&
                                                    <List
                                                        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper', position: 'absolute', zIndex: 99, border: '1px solid #000' }}
                                                        component="nav"
                                                        aria-labelledby="nested-list-subheader"
                                                    >
                                                        <ListItemButton>
                                                            <ListItemText primary="Sent mail" />
                                                        </ListItemButton>
                                                        <ListItemButton>
                                                            <ListItemText primary="Drafts" />
                                                        </ListItemButton>
                                                        <ListItemButton onClick={handleClick}>
                                                            <ListItemText primary="Inbox" />
                                                            {open ? <ExpandLess /> : <ExpandMore />}
                                                        </ListItemButton>
                                                        <Collapse in={open} timeout="auto" unmountOnExit>
                                                            <List component="div" disablePadding>
                                                                <ListItemButton sx={{ pl: 4 }}>
                                                                    <ListItemText primary="Starred" />
                                                                </ListItemButton>
                                                            </List>
                                                        </Collapse>
                                                    </List>
                                                }
                                            </Box>
                                        )
                                    })
                                }
                            </Stack>
                        }
                        {
                            Array.isArray(filters) &&
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                {
                                    onClearFilter && filters.filter(f => f.state[f.field.name]).length > 0 &&
                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button variant='text' size="small" sx={{ cursor: 'pointer', border: '.5px solid grey', px: 0.5, mb: 0.5, borderRadius: 1, fontSize: '0.8rem' }}
                                            onClick={onClearFilter}
                                        >
                                            Clear
                                        </Button>

                                    </Box>
                                }

                                <Box sx={{
                                    display: 'flex', ml: 1, flexWrap: 'wrap',
                                    // justifyContent: 'flex-end'
                                }}>
                                    {
                                        filters.map((filter, f) => {
                                            const { onChange, field, state, data } = filter;
                                            return (
                                                <Box key={f} sx={{ minWidth: filter.minWidth ? filter.minWidth : 120, ml: 1, mb: 1 }}>
                                                    <FieldA field={field} data={data} onChange={onChange} state={state} sxx={{ m: 0 }} />
                                                </Box>
                                            )
                                        })
                                    }
                                </Box>
                            </Box>
                        }
                    </Box>
                </Box>
            </Box>
        </>
    )
}